<script setup lang="ts">
  import BaseListAmp from '~/components/old-recipes/BaseList.amp.vue';
  import type { BaseListElem } from '~/types/components/BaseList';

  defineProps<{
    elem: TContent<{
      items: {
        title: string;
        ingredients: BaseListElem[];
      }[];
    }>;
  }>();
</script>

<template>
  <BaseListAmp
    v-for="(item, idx) in elem.attributes.items"
    :key="idx"
    :items="item.ingredients"
    :title="item.title"
    title-tag-name="h2"
    :hrecipe-ingredient="true"
  />
</template>
